module.exports = __webpack_public_path__ + "static/img/report3d_function02.4c12f9a7.png";